"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inStorePaymentFormErrorTransformer = {
    from: function (errors, intl) {
        var _a, _b, _c;
        var validationErrors = [];
        if (Array.isArray(errors)) {
            for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                var error = errors_1[_i];
                var errorMessage = (_a = String(error.path), (_a !== null && _a !== void 0 ? _a : ''));
                if ((_b = intl.messages) === null || _b === void 0 ? void 0 : _b[errorMessage]) {
                    errorMessage = intl.formatMessage({ id: errorMessage });
                }
                if (!errorMessage) {
                    throw new Error('The validation error is not formatted correctly!');
                }
                validationErrors.push({
                    message: errorMessage,
                    name: error.name,
                    params: null,
                    property: String(error.path),
                    stack: (_c = error.stack, (_c !== null && _c !== void 0 ? _c : '')),
                });
            }
        }
        return validationErrors;
    },
};
exports.default = inStorePaymentFormErrorTransformer;
